import { render, staticRenderFns } from "./new-component.vue?vue&type=template&id=638080b6&scoped=true"
import script from "./new-component.vue?vue&type=script&lang=js"
export * from "./new-component.vue?vue&type=script&lang=js"
import style0 from "./new-component.vue?vue&type=style&index=0&id=638080b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638080b6",
  null
  
)

export default component.exports